<footer class="footer flex items-center justify-between">
  <div class="text-[var(--tui-accent)] font-semibold">
    &copy;CustomsClearSoft
  </div>
</footer>
